import React from 'react';
import httpClient from "./config/http-common";
import { stringify } from 'query-string';
import dataProvider from './dataProvider';
import { data } from "jquery";
import { controllers } from 'chart.js';
const apiUrl = 'http://159.89.46.247:4000/';

export default {

  getList: (resource, { params }) => {
    const { page, perPage } = params.pagination;
    const order = params.sort.order.toLowerCase();
    const field = (params.sort.field === 'id') ? '_id' : params.sort.field;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(params.filter),
      stock: params.stock,
      // service: params.service
    };
    const url = `/${resource}?${stringify(query)}`;
    if (params.token) {
      return httpClient.get(url, { headers: { "Authorization": `Bearer ${params.token}` } }).then(({ data }) =>
      ({
        data: data,
      }));
    }
    else {
      return httpClient.get(url).then(({ data }) => ({
        data: data,
      }));
    }
  },
  getListservice: (resource, { params }) => {
    const order = params.sort.order.toLowerCase();
    const field = (params.sort.field === 'id') ? '_id' : params.sort.field;
    const query = {
      sort: JSON.stringify([field, order]),
      filter: JSON.stringify(params.filter),
      stock: params.stock,
      // service: params.service
    };
    const url = `/${resource}?${stringify(query)}`;
    if (params.token) {
      return httpClient.get(url, { headers: { "Authorization": `Bearer ${params.token}` } }).then(({ data }) =>
      (console.log(data), {
        data: data,
      }));
    }
    else {
      return httpClient.get(url).then(({ data }) => ({
        data: data,
      }));
    }
  },
  getOne: (resource, params) => {
    return httpClient(`/${resource}/${params.id}`).then(({ json }) => ({ data: json }));
  },
  getMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({ data: json }));
  },
  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({
      data: json,
    }));
  },
  update: (resource, params) => {
    const url = `/${resource}/${params.id}/`;
    return httpClient.put(url, params).then(({ data }) => ({
      data: data
    }));
  },
  updateMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`/${resource}?${stringify(query)}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
  create: (resource, params) => {
    const url = `/${resource}`;
    return httpClient.post(url, params).then(({ data }) => ({
      data: data
    }));
  },
  delete: (resource, params) => {
    const url = `/${resource}/${params.id}`;
    return httpClient.delete(url, params).then(({ data }) => ({
      data: data
    }));
  },
  deleteMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`/${resource}?${stringify(query)}`, {
      method: 'DELETE',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
  deleteManyWorkOrderByTenant: (resource, params) => {
    const query = {
      filter: JSON.stringify({ tenantId: params?.tenantId }),
    };
    console.log(query)
    // const url = `/${resource}?${stringify(query)}`;
    // return httpClient(url).then(({ json }) => ({ data: json }));
    return httpClient(`/${resource}?${stringify(query)}`, {
      method: 'DELETE',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
  updateSettings: (resource, params) => {
    const url = `/${resource}`;
    return httpClient.put(url, params).then(({ data }) => ({
      data: data
    }));
  },
  createCategories: (resource, params) => {
    var formData = new FormData();
    if (params.icon && params.icon !== undefined && params.icon[0]) {
      formData.append('icon', params.icon[0]);
    }
    if (params.background && params.background !== undefined && params.background[0]) {
      formData.append('background', params.background[0]);
    }
    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
      else if (typeof (params[key]) === 'object') {
        formData.append(key, JSON.stringify(params[key]));
      }
    }
    const url = `/${resource}`;
    return httpClient.post(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  updateCategories: (resource, params) => {
    var formData = new FormData();
    if (params.icon && params.icon !== undefined && params.icon[0]) {
      formData.append('icon', params.icon[0]);
    }

    if (params.background && params.background !== undefined && params.background[0]) {
      formData.append('background', params.background[0]);
    }
    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
      else {
        formData.append(key, JSON.stringify(params[key]));
      }
    }
    const url = `/${resource}/${params.id}`;
    return httpClient.put(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  sortCategories: (resource, params) => {
    const url = `/${resource}`;
    return httpClient.put(url, params).then(({ data }) => ({
      data: data
    }));
  },
  createBanner: (resource, params) => {
    var formData = new FormData();
    if (params.banner && params.banner !== undefined && params.banner[0]) {
      formData.append('banner', params.banner[0]);
    }
    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
    }
    const url = `/${resource}`;
    return httpClient.post(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  updateBanner: (resource, params) => {
    var formData = new FormData();
    if (params.banner && params.banner !== undefined && params.banner[0]) {
      formData.append('banner', params.banner[0]);
    }
    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
    }
    const url = `/${resource}/${params.id}`;
    return httpClient.put(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  createNotifications: (resource, params) => {
    var formData = new FormData();
    if (params.image && params.image !== undefined && params.image[0]) {
      formData.append('image', params.image[0]);
    }

    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
      else if (typeof (params[key]) === 'object') {
        formData.append(key, JSON.stringify(params[key]));
      }
    }
    const url = `/${resource}`;
    return httpClient.post(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  createWorkorder: (resource, params) => {
    var formData = new FormData();
    if (params.images && params.images !== undefined && params.images) {
      for (var key in params.images) {
        formData.append('images', params.images[key]);
      }
    }
    for (var key in params) {
      if (typeof (params[key]) !== 'object') {
        formData.append(key, params[key]);
      }
      else if (typeof (params[key]) === 'object' && key !== 'images') {
        formData.append(key, JSON.stringify(params[key]));
      }
    }
    const url = `/${resource}`;
    return httpClient.post(url, formData).then(({ data }) => ({
      data: data
    }));
  },
  getOrderView: (params) => {
    const url = `/orders/view/${params.id}`;
    return httpClient.get(url).then(({ data }) => ({
      data: data,
    }));
  },
  getCategory_Place: (params) => {
    const url = `/category/places/${params.id}`;
    return httpClient.get(url).then(({ data }) => ({
      data: data,
    }));
  },
  updateEmail: (resource, params) => {
    const url = `/${resource}`;
    return httpClient.put(url, params).then(({ data }) => ({
      data: data
    }));
  },
  getDashboard: (params) => {
    const url = `/reports/dashboard/`;
    return httpClient.get(url).then(({ data }) => ({
      data: data,
    }));
  },
  getReport: (params) => {
    const query = {
      workorder: JSON.stringify(params.workorder),
      category: JSON.stringify(params.category)
    };
    const url = `/reports?${stringify(query)}`;
    return httpClient.get(url, { headers: { "Authorization": `Bearer ${params.token}` } }).then(({ data }) => ({
      data: data,
    }));
  },
  getPartsOne: (resource, params) => {
    return httpClient(`/${resource}/${params.id}`).then(({ data }) => ({ data: data }));
  },
  getTenantOne: (resource, params) => {
    return httpClient(`/${resource}/${params.id}`).then(({ data }) => ({ data: data }));
  },
  getTechnicians: (resource, params) => {
    const query = {
      filter: JSON.stringify(params.filter)
    };
    const url = `/${resource}?${stringify(query)}`;
    if (params.token) {
      return httpClient.get(url, { headers: { "Authorization": `Bearer ${params.token}` } }).then(({ data }) =>
      ({
        data: data,
      }));
    }
    else {
      return httpClient.get(url).then(({ data }) => ({
        data: data,
      }));
    }
  },
  getSublocation_filter: (resource, params) => {
    console.log(params, resource);
    const { page, perPage } = params.pagination;
    const order = params.sort.order.toLowerCase();
    const field = (params.sort.field === 'id') ? '_id' : params.sort.field;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      productId: params.productId,
    };
    const url = `/${resource}?${stringify(query)}`;
    if (params.token) {
      return httpClient.get(url, { headers: { "Authorization": `Bearer ${params.token}` } }).then(({ data }) =>
      ({
        data: data,
      }));
    }
    else {
      return httpClient.get(url).then(({ data }) => ({
        data: data,
      }));
    }
  },
};

